import * as yup from 'yup';

export const categorySchema = yup.object({
  name: yup.string().required('Name is required'),
  emoji: yup.string().required('Emoji is required'),
});

export const subcategorySchema = yup.object({
  name: yup.string().required('Name is required'),
});

